export const EMPTY_OBJECT = Object.freeze({})
export const NOOP = () => undefined
export const MAX_MOBILE_WIDTH = 960
// The DS (Panda) desktop layout begins at the `lg` breakpoint (min-width: 1200px).
export const DS_DESKTOP_MIN_WIDTH = 1200
export const MAX_DESKTOP_WIDTH = 1600
// @i18n-ignore
export const QUINCE = 'Quince'
export const EN_US = 'en_US'
// @i18n-ignore
export const CONTENT_QUERY_PARAM = 'content-version'
// @i18n-ignore
export const NO_COLOR_OPTION_NAME = 'No Color'
